import { createSelector } from '@reduxjs/toolkit'
import type { RootState } from 'app'

export const getUiState = (state: RootState) => state.common.ui

export const getDialogSettings = createSelector(
  getUiState,
  state => state.dialog
)

export const getCommonDialogsState = createSelector(
  getUiState,
  state => state.commonDialogs
)
export const getBankTransferVerificationDialogOpen = createSelector(
  getUiState,
  state => state.bankTransferVerificationDialogOpen
)

export const getLawsuitSignatureDialogOpen = createSelector(
  getUiState,
  state => state.lawsuitSignatureDialogOpen
)

export const getUploadFiledLawsuitDialogOpen = createSelector(
  getUiState,
  state => state.uploadFiledLawsuitDialogOpen
)

export const getUpdateLawsuitDialogOpen = createSelector(
  getUiState,
  state => state.updateLawsuitDialogOpen
)
